import * as RestApi from 'core/network/RestApi';
import { BulkRetargetingCampaign } from 'models/offsite/Campaign/BulkRetargetingCampaign';

export interface GetBulkRetargetingCampaignEstimateQueryRequest {
  campaign: Partial<BulkRetargetingCampaign>;
}

export const getBulkRetargetingCampaignEstimateQuery = async ({
  campaign,
}: GetBulkRetargetingCampaignEstimateQueryRequest) => {
  const result = await RestApi.post<number, Partial<BulkRetargetingCampaign>>(
    `/sites/${campaign.siteId}/bulk_retargeting_campaigns/${campaign.id}/estimate`,
    campaign,
  );
  return result.data;
};
